/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { OrgInviteCreateRequest } from '../models/OrgInviteCreateRequest';
import type { OrgInviteCreateResponse } from '../models/OrgInviteCreateResponse';
import type { OrgInviteResponse } from '../models/OrgInviteResponse';
import type { PaginatedResponse_OrgInviteResponse_ } from '../models/PaginatedResponse_OrgInviteResponse_';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class OrgInviteService {
    /**
     * Create Org Invite
     *     기관 초대 생성 (단일/다중)
     *
     * 새로운 기관 초대를 생성합니다. 단일 이메일 또는 다중 이메일을 지원합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns OrgInviteCreateResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsCreateOrgInvite({
        requestBody,
    }: {
        requestBody: OrgInviteCreateRequest,
    }): CancelablePromise<OrgInviteCreateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/org/invite',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * List Org Invites
     *     기관 초대 목록 조회 및 검색
     *
     * 기관 초대를 페이징하여 조회합니다. 검색 키워드가 제공되면 검색을 수행합니다.
     *
     * Args:
     * org_id: 기관 ID로 필터링 (선택사항)
     * q: 검색 키워드 (선택사항) - 이메일로 검색
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns PaginatedResponse_OrgInviteResponse_ OK
     * @throws ApiError
     */
    public static appsOrganizationViewsListOrgInvites({
        orgId,
        q,
        page = 1,
        perPage = 100,
    }: {
        orgId?: string,
        q?: string,
        page?: number,
        perPage?: number,
    }): CancelablePromise<PaginatedResponse_OrgInviteResponse_> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org/invite',
            query: {
                'org_id': orgId,
                'q': q,
                'page': page,
                'per_page': perPage,
            },
            errors: {
                403: `Forbidden`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get Org Invite
     * 기관 초대 조회
     *
     * ID로 특정 기관 초대를 조회합니다.
     * @returns OrgInviteResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsGetOrgInvite({
        inviteId,
    }: {
        inviteId: string,
    }): CancelablePromise<OrgInviteResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/org/invite/{invite_id}',
            path: {
                'invite_id': inviteId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Delete Org Invite
     *     기관 초대 삭제
     *
     * 특정 기관 초대를 삭제합니다.
     *
     * ⚠️ **권한 필요**: 기관 관리자(owner 또는 admin) 권한이 필요합니다.
     * - 권한이 없는 경우 403 Forbidden 응답이 반환됩니다.
     * @returns any OK
     * @throws ApiError
     */
    public static appsOrganizationViewsDeleteOrgInvite({
        inviteId,
    }: {
        inviteId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/org/invite/{invite_id}',
            path: {
                'invite_id': inviteId,
            },
            errors: {
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Accept Org Invite
     * 기관 초대 수락
     *
     * 특정 기관 초대를 수락합니다.
     *
     * Args:
     * invite_id: 초대 ID
     * account_id: 수락할 계정 ID
     * @returns OrgInviteResponse OK
     * @throws ApiError
     */
    public static appsOrganizationViewsAcceptOrgInvite({
        inviteId,
        accountId,
    }: {
        inviteId: string,
        accountId: string,
    }): CancelablePromise<OrgInviteResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/org/invite/{invite_id}/accept',
            path: {
                'invite_id': inviteId,
            },
            query: {
                'account_id': accountId,
            },
            errors: {
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
}
